 
import React, { ReactElement } from 'react';

import { SkeletonBase } from '@digital-dealer/components';

const TabletSkeleton = (): ReactElement => (
  <SkeletonBase viewBox="0 0 736 740">
    <rect
      width={132}
      height={24}
      rx={4}
    />
    <rect
      y={32}
      width={651}
      height={16}
      rx={4}
    />
    <rect
      y={60}
      width={360}
      height={160}
      rx={4}
    />
    <rect
      y={232}
      width={360}
      height={16}
      rx={4}
    />
    <rect
      y={260}
      width={149}
      height={16}
      rx={4}
    />
    <rect
      x={376}
      y={60}
      width={360}
      height={160}
      rx={4}
    />
    <rect
      x={376}
      y={232}
      width={360}
      height={16}
      rx={4}
    />
    <rect
      x={376}
      y={260}
      width={149}
      height={16}
      rx={4}
    />
    <rect
      y={292}
      width={360}
      height={160}
      rx={4}
    />
    <rect
      y={464}
      width={360}
      height={16}
      rx={4}
    />
    <rect
      y={492}
      width={149}
      height={16}
      rx={4}
    />
    <rect
      x={376}
      y={292}
      width={360}
      height={160}
      rx={4}
    />
    <rect
      x={376}
      y={464}
      width={360}
      height={16}
      rx={4}
    />
    <rect
      x={376}
      y={492}
      width={149}
      height={16}
      rx={4}
    />
    <rect
      y={524}
      width={360}
      height={160}
      rx={4}
    />
    <rect
      y={696}
      width={360}
      height={16}
      rx={4}
    />
    <rect
      y={724}
      width={149}
      height={16}
      rx={4}
    />
    <rect
      x={376}
      y={524}
      width={360}
      height={160}
      rx={4}
    />
    <rect
      x={376}
      y={696}
      width={360}
      height={16}
      rx={4}
    />
    <rect
      x={376}
      y={724}
      width={149}
      height={16}
      rx={4}
    />
  </SkeletonBase>
);

export default TabletSkeleton;
